import { render, staticRenderFns } from "./Registrering.vue?vue&type=template&id=1f6d89ae&scoped=true&"
import script from "./Registrering.vue?vue&type=script&lang=js&"
export * from "./Registrering.vue?vue&type=script&lang=js&"
import style0 from "./Registrering.vue?vue&type=style&index=0&id=1f6d89ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d89ae",
  null
  
)

export default component.exports